import CompaniesLevelsMainPage from './main';
import CompaniesLevelsEdit from './edit';
import SingleCompaniesLevels from './singleCategory';

const routes = [
    {
        path: '/*',
        Component: CompaniesLevelsMainPage,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: CompaniesLevelsEdit,
        props: {},
    },
    {
        path: '/:id',
        Component: SingleCompaniesLevels,
        props: {},
    },
    {
        path: '/new',
        Component: CompaniesLevelsEdit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
